export const ru = {
    yandex_trip: 'Яндекс Командировки',
    yandex: 'Яндекс',
    account_manager: 'Менеджер по работе с клиентами Сергей Алентьев',
    account_manager_phone: '+7 911 249-56-60',
    account_manager_telegram: 'Telegram',
};
